module.exports = __webpack_public_path__ + "img/hot_sgyl.e1b44c7a.svg";